import React from 'react';
import styles from './MfZateceno.module.css';

/**
 * Šta je od ciljeva uvoza već na lancu — rečima, po kompoziciji.
 *
 * POVOD (09.10.2026): isti dump uvezen dvaput dao je svaki red dvaput, bez
 * ijedne reči. Server sada to kaže (`/structure` vraća `existing`, a uvoz bez
 * potvrde odgovara 409); ovde se to pretvara u rečenicu koja kaže ŠTA će se
 * desiti, ne samo da nešto postoji.
 *
 * @param {{stavke: Array<{composition: string, rows: number|null, identity: string|null,
 *   effect: 'append'|'replace', unknownFields: string[]}>}} props
 */
const MfZateceno = ({ stavke }) => {
    if (!stavke?.length) return null;

    return (
        <div className={styles.zateceno} role="alert">
            {stavke.map((z) => (
                <p key={z.composition}>{recenica(z)}</p>
            ))}
        </div>
    );
};

const redova = (n) => (n === null || n === undefined
    ? 'an unknown number of rows'
    : `${n} row${n === 1 ? '' : 's'}`);

export const recenica = (z) => {
    if (z.unknownFields?.length) {
        return `'${z.composition}' already exists with a different structure — it does not `
            + `define ${z.unknownFields.join(', ')}. This import will be refused; use a new name.`;
    }
    return z.effect === 'replace'
        ? `'${z.composition}' already holds ${redova(z.rows)}. Rows with the same `
            + `'${z.identity}' will be replaced, the rest added.`
        : `'${z.composition}' already holds ${redova(z.rows)}. This import adds its rows `
            + 'next to them — a row imported twice appears twice.';
};

/**
 * Ono od zatečenog što se tiče imena koja su SADA izabrana. Server je u koraku
 * 1 izmerio predložena imena; za drugo ime presuđuje sam uvoz (409).
 */
export const zaImena = (existing, imena) => {
    const izabrana = new Set(imena.filter(Boolean));
    return (existing || []).filter((z) => izabrana.has(z.composition));
};

export default MfZateceno;
